/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Agroevidence API
 * OpenAPI spec version: 1.0.0
 */
import { customFetch } from '../../shared/api/client';
import { serializeParams } from '../../shared/api/client';
export type FarmType = typeof FarmType[keyof typeof FarmType];


export const FarmType = {
  CLEVER_FARM: 'CLEVER_FARM',
  CLEVER_GREEN: 'CLEVER_GREEN',
} as const;

export interface FarmTypeUpdateTo {
  farmType: FarmType;
}

export type Module = typeof Module[keyof typeof Module];


export const Module = {
  maplayers: 'map.layers',
  mapparcels: 'map.parcels',
  mapthematic_maps: 'map.thematic_maps',
  maptelematics: 'map.telematics',
  precision_farming: 'precision_farming',
  precision_farmingmachine_data: 'precision_farming.machine_data',
  precision_farmingprescription_maps: 'precision_farming.prescription_maps',
  telematics: 'telematics',
  irrigation: 'irrigation',
  activities: 'activities',
  stores: 'stores',
  reports: 'reports',
  catalogues: 'catalogues',
} as const;

export interface ModulesUpdateTo {
  disabledModules: Module[];
}

export interface InternalFarmCreate {
  id: string;
  countryCode: string;
  userId: string;
  farmType: FarmType;
}

export interface FarmUserTo {
  farmId: string;
  userId: string;
  email: string;
}

export interface InternalFarmUser {
  userId: string;
}

export interface InternalFarm {
  id: string;
  countryCode: string;
}

export interface DisabledModulesTo {
  disabledModules: Module[];
}

export interface FarmTypeTo {
  farmType: FarmType;
}

export interface DisabledModuleTemplateTo {
  farmType: FarmType;
  disabledModules: Module[];
}

export interface FarmTo {
  id: string;
  countryCode: string;
}

type AdminGetFarmTypeParamsTSMorphBase = {
farmIds: string;
}

export type AdminGetFarmTypeParams = Omit<AdminGetFarmTypeParamsTSMorphBase, "farmIds">;;

type AdminSetFarmTypeParamsTSMorphBase = {
farmIds: string;
}

export type AdminSetFarmTypeParams = Omit<AdminSetFarmTypeParamsTSMorphBase, "farmIds">;;

type AdminGetDisabledModulesParamsTSMorphBase = {
farmIds: string;
}

export type AdminGetDisabledModulesParams = Omit<AdminGetDisabledModulesParamsTSMorphBase, "farmIds">;;

type AdminDisableModulesParamsTSMorphBase = {
farmIds: string;
}

export type AdminDisableModulesParams = Omit<AdminDisableModulesParamsTSMorphBase, "farmIds">;;

type GetFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetFarmUsersParams = Omit<GetFarmUsersParamsTSMorphBase, "farmIds">;;

export type AddFarmUserParams = {
farmIds: string;
'user-id': string;
};

export type DeleteFarmUserParams = {
farmIds: string;
'user-id': string;
};

type GetInternalFarmUsersParamsTSMorphBase = {
farmIds: string;
}

export type GetInternalFarmUsersParams = Omit<GetInternalFarmUsersParamsTSMorphBase, "farmIds">;;

export type GetFarmsByUserIdParams = {
'user-id': string;
};

type GetDisabledModulesParamsTSMorphBase = {
farmIds: string;
}

export type GetDisabledModulesParams = Omit<GetDisabledModulesParamsTSMorphBase, "farmIds">;;

export type GetFarmsByUserId1Params = {
'user-id': string;
};

export type adminGetFarmTypeResponse200 = {
  data: FarmTypeTo
  status: 200
}

export type adminGetFarmTypeResponseSuccess = (adminGetFarmTypeResponse200) & {
  headers: Headers;
};
;

export const getAdminGetFarmTypeUrl = (params: AdminGetFarmTypeParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type`
}

/**
 * Returns the farm type label for the specified farm
 * @summary Get the farm type
 */
export const adminGetFarmType = async (params: AdminGetFarmTypeParams, options?: Parameters<typeof customFetch>[1]): Promise<adminGetFarmTypeResponseSuccess> => {

  return customFetch<adminGetFarmTypeResponseSuccess>(getAdminGetFarmTypeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminSetFarmTypeResponse200 = {
  data: void
  status: 200
}

export type adminSetFarmTypeResponseSuccess = (adminSetFarmTypeResponse200) & {
  headers: Headers;
};
;

export const getAdminSetFarmTypeUrl = (params: AdminSetFarmTypeParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/type`
}

/**
 * Sets the farm type label. The farm's stored module configuration is not affected.
 * @summary Set the farm type
 */
export const adminSetFarmType = async (farmTypeUpdateTo: FarmTypeUpdateTo,
    params: AdminSetFarmTypeParams, options?: Parameters<typeof customFetch>[1]): Promise<adminSetFarmTypeResponseSuccess> => {

  return customFetch<adminSetFarmTypeResponseSuccess>(getAdminSetFarmTypeUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(farmTypeUpdateTo)
  }
);}



export type adminGetDisabledModulesResponse200 = {
  data: DisabledModulesTo
  status: 200
}

export type adminGetDisabledModulesResponseSuccess = (adminGetDisabledModulesResponse200) & {
  headers: Headers;
};
;

export const getAdminGetDisabledModulesUrl = (params: AdminGetDisabledModulesParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled`
}

/**
 * Returns the set of disabled module keys for the specified farm
 * @summary Get the farm's disabled modules
 */
export const adminGetDisabledModules = async (params: AdminGetDisabledModulesParams, options?: Parameters<typeof customFetch>[1]): Promise<adminGetDisabledModulesResponseSuccess> => {

  return customFetch<adminGetDisabledModulesResponseSuccess>(getAdminGetDisabledModulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminDisableModulesResponse200 = {
  data: void
  status: 200
}

export type adminDisableModulesResponseSuccess = (adminDisableModulesResponse200) & {
  headers: Headers;
};
;

export const getAdminDisableModulesUrl = (params: AdminDisableModulesParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled`
}

/**
 * Replaces the set of disabled module keys for the specified farm in one call
 * @summary Set the farm's disabled modules
 */
export const adminDisableModules = async (modulesUpdateTo: ModulesUpdateTo,
    params: AdminDisableModulesParams, options?: Parameters<typeof customFetch>[1]): Promise<adminDisableModulesResponseSuccess> => {

  return customFetch<adminDisableModulesResponseSuccess>(getAdminDisableModulesUrl(params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(modulesUpdateTo)
  }
);}



export type createFarmResponse200 = {
  data: void
  status: 200
}

export type createFarmResponseSuccess = (createFarmResponse200) & {
  headers: Headers;
};
;

export const getCreateFarmUrl = () => {


  return `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms`
}

/**
 * Creates a new farm with the provided information
 * @summary Create a new farm
 */
export const createFarm = async (internalFarmCreate: InternalFarmCreate, options?: Parameters<typeof customFetch>[1]): Promise<createFarmResponseSuccess> => {

  return customFetch<createFarmResponseSuccess>(getCreateFarmUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(internalFarmCreate)
  }
);}



export type getFarmUsersResponse200 = {
  data: FarmUserTo[]
  status: 200
}

export type getFarmUsersResponseSuccess = (getFarmUsersResponse200) & {
  headers: Headers;
};
;

export const getGetFarmUsersUrl = (params: GetFarmUsersParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`
}

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getFarmUsers = async (params: GetFarmUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<getFarmUsersResponseSuccess> => {

  return customFetch<getFarmUsersResponseSuccess>(getGetFarmUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type addFarmUserResponse200 = {
  data: FarmUserTo
  status: 200
}

export type addFarmUserResponseSuccess = (addFarmUserResponse200) & {
  headers: Headers;
};
;

export const getAddFarmUserUrl = (params: AddFarmUserParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`
}

/**
 * Adds a user to a farm with the specified IDs
 * @summary Add a user to a farm
 */
export const addFarmUser = async (params: AddFarmUserParams, options?: Parameters<typeof customFetch>[1]): Promise<addFarmUserResponseSuccess> => {

  return customFetch<addFarmUserResponseSuccess>(getAddFarmUserUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}



export type deleteFarmUserResponse200 = {
  data: void
  status: 200
}

export type deleteFarmUserResponseSuccess = (deleteFarmUserResponse200) & {
  headers: Headers;
};
;

export const getDeleteFarmUserUrl = (params: DeleteFarmUserParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/users`
}

/**
 * Removes a user from a farm with the specified IDs
 * @summary Remove a user from a farm
 */
export const deleteFarmUser = async (params: DeleteFarmUserParams, options?: Parameters<typeof customFetch>[1]): Promise<deleteFarmUserResponseSuccess> => {

  return customFetch<deleteFarmUserResponseSuccess>(getDeleteFarmUserUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type getInternalFarmUsersResponse200 = {
  data: InternalFarmUser[]
  status: 200
}

export type getInternalFarmUsersResponseSuccess = (getInternalFarmUsersResponse200) & {
  headers: Headers;
};
;

export const getGetInternalFarmUsersUrl = (params: GetInternalFarmUsersParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/users/by-farm?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/users/by-farm`
}

/**
 * Retrieves all users associated with the specified farm ID
 * @summary Get users for a farm
 */
export const getInternalFarmUsers = async (params: GetInternalFarmUsersParams, options?: Parameters<typeof customFetch>[1]): Promise<getInternalFarmUsersResponseSuccess> => {

  return customFetch<getInternalFarmUsersResponseSuccess>(getGetInternalFarmUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getFarmsByUserIdResponse200 = {
  data: InternalFarm[]
  status: 200
}

export type getFarmsByUserIdResponseSuccess = (getFarmsByUserIdResponse200) & {
  headers: Headers;
};
;

export const getGetFarmsByUserIdUrl = (params: GetFarmsByUserIdParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/by-user?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/internal-api/farms/by-user`
}

/**
 * Retrieves all farms associated with the specified user ID
 * @summary Get farms by user ID
 */
export const getFarmsByUserId = async (params: GetFarmsByUserIdParams, options?: Parameters<typeof customFetch>[1]): Promise<getFarmsByUserIdResponseSuccess> => {

  return customFetch<getFarmsByUserIdResponseSuccess>(getGetFarmsByUserIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type getDisabledModulesResponse200 = {
  data: DisabledModulesTo
  status: 200
}

export type getDisabledModulesResponseSuccess = (getDisabledModulesResponse200) & {
  headers: Headers;
};
;

export const getGetDisabledModulesUrl = (params: GetDisabledModulesParams,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/farms/modules/disabled?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/farms/modules/disabled`
}

/**
 * Returns the set of disabled module keys for the specified farm
 * @summary Get the farm's disabled modules
 */
export const getDisabledModules = async (params: GetDisabledModulesParams, options?: Parameters<typeof customFetch>[1]): Promise<getDisabledModulesResponseSuccess> => {

  return customFetch<getDisabledModulesResponseSuccess>(getGetDisabledModulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminGetDisabledModuleTemplatesResponse200 = {
  data: DisabledModuleTemplateTo[]
  status: 200
}

export type adminGetDisabledModuleTemplatesResponseSuccess = (adminGetDisabledModuleTemplatesResponse200) & {
  headers: Headers;
};
;

export const getAdminGetDisabledModuleTemplatesUrl = () => {


  return `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/modules/disabled/templates`
}

/**
 * Returns the default disabled module keys for every farm type. Read-only: applying a template is a separate call to PUT /disabled.
 * @summary Get the disabled module templates
 */
export const adminGetDisabledModuleTemplates = async ( options?: Parameters<typeof customFetch>[1]): Promise<adminGetDisabledModuleTemplatesResponseSuccess> => {

  return customFetch<adminGetDisabledModuleTemplatesResponseSuccess>(getAdminGetDisabledModuleTemplatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type getFarmsByUserId1Response200 = {
  data: FarmTo[]
  status: 200
}

export type getFarmsByUserId1ResponseSuccess = (getFarmsByUserId1Response200) & {
  headers: Headers;
};
;

export const getGetFarmsByUserId1Url = (params: GetFarmsByUserId1Params,) => {
  const stringifiedParams = serializeParams(params);

  return stringifiedParams.length > 0 ? `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/by-user?${stringifiedParams}` : `${window.ENV.FARM_MANAGEMENT_URL}/api/admin/farms/by-user`
}

/**
 * Retrieves all farms associated with the specified user ID
 * @summary Get farms by user ID
 */
export const getFarmsByUserId1 = async (params: GetFarmsByUserId1Params, options?: Parameters<typeof customFetch>[1]): Promise<getFarmsByUserId1ResponseSuccess> => {

  return customFetch<getFarmsByUserId1ResponseSuccess>(getGetFarmsByUserId1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}
